import {
  BANK,
  INVESTOR_OBJECT,
  INVETSOR_DETAILS_RESPONSE,
  PINCODE,
} from "../../../redux-store/types/nct";
import {
  IsAllow,
  PORTFOLIO_DATA_RESPONSE,
  SCHEMES_RESPONSE,
} from "../../../redux-store/types/portfolio";
import { DividendTableRowType } from "../makeNct/ChangeIdcw";
import { RowInfoType } from "../makeNct/ChangeEmail/change-email-list";
import { ConsolidateTableRowType } from "../makeNct/ConsolidationFolios/types";
import { NomineeInfoRowData } from "../makeNct/UpdateNominee/types";
import { EIGHTEEN_YEARS_IN_MILLISECONDS } from "../../../utils/constants";
import moment from "moment";
import enUs from "../../../lang/en-us";
import { TaxDetails } from "../commercial/ExploreMFs/types";

const { dbCommercial, dashboard } = enUs;

export const getTaxStatusCode: { [key: string]: string } = {
  "01": "Individual",
  "02": "On Behalf Of Minor",
  "21": "NRI-Repatriable (NRE)",
  "24": "NRI - NRO [Non Repatriation]",
  "26": "NRI - Minor",
  "27": "NRI - HUF (NRO)",
  "28": "NRI - Minor (NRO)",
  "29": "NRI - HUF (NRE)",
};

export const NRICODES_CT = ["24"];

export const gettaxStatusPersonal: { [key: string]: string } = {
  "01": "Individual",
  // "24": "NRI - NRO [Non Repatriable]",
};

export const getRelationShip: { [key: string]: string } = {
  SE: "Self",
  SP: "Spouse",
  DC: "Dependent Children",
  DS: "Dependent Siblings",
  DP: "Dependent Parents",
  GD: "Guardian",
  PM: "PMS",
  CD: "Custodian",
  PO: "POA",
  // "24": "NRI - NRO [Non Repatriable]",
};

export const getIncomeValue: { [key: string]: string } = {
  "31": "Below 1 Lakh",
  "32": "1- 5 Lacs",
  "33": "5-10 Lacs",
  "34": "10-25 Lacs",
  "35": "25 Lacs-1 Crore",
  "36": "Above 1 Crore",
};
export const getPepValue: { [key: string]: string } = {
  Y: "Yes",
  N: "No",
};

export const getOccupation: { [key: string]: string } = {
  "1": "Business",
  "2": "Service",
  "3": "Professional",
  "4": "Agriculturist",
  "5": "Retired",
  "6": "Housewife",
  "7": "Student",
  "8": "Others",
  "41": "Private Sector Service",
  "42": "Public Sector/ Government Service",
  "43": "Forex Dealer",
  "44": "Government Service",
};

export const getAddressType: { [key: string]: string } = {
  RB: "Residential or Business",
  R: "Residential",
  B: "Business",
  RO: "Registered Office",
};

export const getSourceOfWealth: { [key: string]: string } = {
  "1": "Salary",
  "2": "Business Income",
  "3": "Gift",
  "4": "Ancestral Property",
  "5": "Rental Income",
  "6": "Prize Money",
  "7": "Royalty",
  "8": "Others",
};

export const NRI_CODES = ["21", "24", "26", "27", "28", "29"];

interface GroupSchemesByTypeAndAMC {
  equity?: SCHEMES_RESPONSE[];
  debt?: SCHEMES_RESPONSE[];
  liquid?: SCHEMES_RESPONSE[];
}

const initData: GroupSchemesByTypeAndAMC = { equity: [], debt: [], liquid: [] };

// Sorting portfolio response with assetType.(Liquid and Cash are identical types considering as Liquid)
export function groupByAmcName(data: PORTFOLIO_DATA_RESPONSE[] = []) {
  const out = data.reduce((prev: any, curr: PORTFOLIO_DATA_RESPONSE) => {
    const { schemes } = curr;
    let filterSchemesByType: any = {};
    schemes.forEach((scheme: SCHEMES_RESPONSE) => {
      const {
        assetType: _assetType,
        currentMktValue: _currentMktValue,
        costValue: _costValue,
      } = scheme;
      const assetToUpperCase = _assetType?.toUpperCase();
      // need to be replaced with below line if cash and liquid are different.
      // const assetType = _assetType !== null ? assetToUpperCase : _assetType
      const assetType =
        _assetType !== null
          ? ["LIQUID", "CASH"].includes(assetToUpperCase)
            ? "LIQUID"
            : assetToUpperCase
          : _assetType;
      if (!!filterSchemesByType[assetType]) {
        const { currentMktValue, costValue }: SCHEMES_RESPONSE =
          filterSchemesByType[assetType];
        filterSchemesByType = {
          ...filterSchemesByType,
          [assetType]: {
            ...filterSchemesByType[assetType],
            currentMktValue: decimalFix(
              // Adding all mkt and cost values for same asset type.
              Number(currentMktValue) + Number(_currentMktValue)
            ),
            costValue: decimalFix(Number(costValue) + Number(_costValue)),
          },
        };
      } else {
        filterSchemesByType = { ...filterSchemesByType, [assetType]: scheme };
      }
    });
    const { EQUITY, DEBT, LIQUID } = filterSchemesByType;
    prev = {
      equity: EQUITY ? [...prev.equity, EQUITY] : prev.equity,
      debt: DEBT ? [...prev.debt, DEBT] : prev.debt,
      liquid: LIQUID ? [...prev.liquid, LIQUID] : prev.liquid,
    };
    return prev;
  }, initData);
  return out;
}

export function calculateGainOrLoss(schemes: any) {
  const keys: any[] = Object.keys(schemes);
  return keys.reduce((prev: any, key: any) => {
    const schemesByType: SCHEMES_RESPONSE[] = schemes[key];
    schemesByType.forEach((scheme) => {
      const { costValue = 0, currentMktValue = 0 } = scheme;
      const gainLoss = Number(currentMktValue) - Number(costValue);
      const gainLossPercentage = (Number(gainLoss) * 100) / Number(costValue);
      prev = {
        ...prev,
        [key]: [
          ...(prev[key] || []),
          {
            ...scheme,
            gainLossPercentage: decimalFix(gainLossPercentage),
            gainLoss: decimalFix(gainLoss),
          },
        ],
      };
    });
    return prev;
  }, {});
}

export function decimalFix(value: number = 0, fixed: number = 2) {
  if (isNaN(value)) {
    return 0;
  }
  return Number(parseFloat(value.toString()).toFixed(fixed));
}
export function dateConvert(date: Date | string) {
  // let options: Intl.DateTimeFormatOptions = {
  //   weekday: "long",
  //   year: "numeric",
  //   month: "long",
  //   day: "numeric",
  // };
  const d = new Date(date);
  if (!isNaN(d.getTime())) {
    d.setFullYear(Math.abs(d.getFullYear()));
    return moment(d).format("dddd, MMMM DD, YYYY");
  } else {
    if (!date) return "";
    const today = moment(date);
    return today.format("dddd, MMMM DD, YYYY");
  }

  // const today = moment(new Date(date), "DD-MMM-YYYY");
  // return today.format("dddd, MMMM DD, YYYY");
}

export function getAssetTypeValues(data: any = {}) {
  return Object.keys(data).reduce((prev: any, curr: any) => {
    const schemes: SCHEMES_RESPONSE[] = data[curr];
    let costValue = 0;
    let currentMktValue = 0;
    schemes.forEach((ele: SCHEMES_RESPONSE) => {
      costValue = Number(ele.costValue) + costValue;
      currentMktValue = Number(ele.currentMktValue) + currentMktValue;
    });
    return {
      ...prev,
      [curr]: {
        costValue: decimalFix(costValue),
        currentMktValue: decimalFix(currentMktValue),
      },
    };
  }, {});
}
/**
 * Portfolio Table Filters for Change Email , Change Mobile and Change Dividend
 * @param transactionStatus
 * @returns
 */
export const portfoliosByTransactionResource = ({
  transactionSource = "",
}: SCHEMES_RESPONSE): boolean => {
  const transactionSourceToUpper = transactionSource?.toUpperCase();
  return !(
    transactionSourceToUpper === "DEMAT" ||
    // transactionSourceToUpper === "MFU" ||
    transactionSourceToUpper === "EXCHANGE"
  );
};

export const isNotDemat = ({ isDemat }: SCHEMES_RESPONSE): boolean => {
  return isDemat === IsAllow.No;
};

export const noLienUnits = ({
  lienEligibleUnits,
}: SCHEMES_RESPONSE): boolean => {
  const lienUnitsAvailabe = Number(lienEligibleUnits) > 0;
  return !lienUnitsAvailabe;
};
export const portfoliosByReinvestment = ({
  schemeOption,
}: SCHEMES_RESPONSE): boolean => {
  const schemeToUpper = schemeOption?.toUpperCase();
  return Boolean(schemeToUpper?.includes("REINVEST"));
  // schemeToUpper === "IDCW REINVEST" ||
  // schemeToUpper === "REINVESTMENT" ||
  // schemeToUpper === "IDCW REINVESTMENT" ||
  // schemeToUpper === "REINVEST"
};

export const portfoliosByPayout = ({
  schemeOption,
}: SCHEMES_RESPONSE): boolean => {
  const schemeToUpper = schemeOption?.toUpperCase();
  return Boolean(schemeToUpper?.includes("PAYOUT"));
  // return schemeToUpper === "IDCW PAYOUT" || schemeToUpper === "PAYOUT";
};

export const portfoliosByMinorStatus = ({
  taxStatus,
  age = 0,
  dob = null,
  ...rest
}: SCHEMES_RESPONSE): boolean => {
  const taxToUpper = taxStatus?.toUpperCase() || "";
  return (
    (taxToUpper === "02" ||
      taxToUpper === "01" ||
      NRI_CODES.includes(taxToUpper)) &&
    minorBelowEighteenYears({ taxStatus, age, dob, ...rest })
  );
};

export const ctPortfoliosByBankAccount = ({ bank }: SCHEMES_RESPONSE): boolean => {
  return Boolean(bank?.accountType && bank.accountNo);
}

export const ctPortfoliosByMinorStatus = ({
  taxStatus,
  age = 0,
  dob = null,
  bank,
  ...rest
}: SCHEMES_RESPONSE): boolean => {
  const accountType = !!bank ? bank.accountType : null;
  if (!taxStatus || !accountType) {
    return false;
  }

  return (
    taxStatus === "01" ||
    minorBelowEighteenYears({ taxStatus, age, dob, ...rest })
  );
};

export const ctPortfoliosByNROAccountType = ({
  taxStatus,
  age = 0,
  dob = null,
  bank,
  ...rest
}: SCHEMES_RESPONSE): boolean => {
  const accountType = !!bank ? bank.accountType : null;
  if (!taxStatus || !accountType) {
    return false;
  }

  const isNRI = NRI_CODES.includes(taxStatus);

  if (isNRI) {
    return (
      NRICODES_CT.includes(taxStatus) && accountType?.toUpperCase() === "NRO"
    );
  }

  return true;
};

export const portfoliosByIdcwStatus = ({
  idcwChangeAllowed,
}: SCHEMES_RESPONSE): boolean => idcwChangeAllowed === "True";

export const portfoliosByClosingBalance = ({
  closingBalance = 0,
}: SCHEMES_RESPONSE): boolean => Number(closingBalance) > 0;

export const portfoliosByModeOfHolding = ({
  modeOfHolding = "",
}: SCHEMES_RESPONSE): boolean => {
  const modeOfHoldingUpper = modeOfHolding?.toUpperCase();
  return (
    modeOfHoldingUpper === "SINGLE" ||
    modeOfHoldingUpper === "ANYONE/SURVIVOR" ||
    modeOfHoldingUpper === "ANYONE OR SURVIVOR" ||
    modeOfHoldingUpper === "EITHER/SURVIVOR" ||
    modeOfHoldingUpper === "EITHER OR SURVIVOR"
  );
};

export const portfoliosByPurchaseAllow = ({ purAllow = "N" }: any): boolean => {
  return purAllow === "Y";
};

export const portfoliosByPurchaseOrSipAllow = ({
  purAllow = "N",
  sipAllow = "N",
}: any): boolean => {
  return purAllow === "Y" || sipAllow === "Y";
};
export const portfoliosBySipAllow = ({ sipAllow = "N" }: any): boolean => {
  return sipAllow === "Y";
};

export const disablePaytmBankForGrow = ({
  redAllow,
  amc,
  bank,
}: SCHEMES_RESPONSE): boolean => {
  if (Number(amc) !== 125) return true;
  const bankName = bank?.name?.toLowerCase();
  if (bankName && bankName.includes("paytm") && redAllow === IsAllow.No) {
    return false;
  }
  return true;
};

export const portfoliosByRedemptionAllow = ({
  redAllow = "F",
}: any): boolean => {
  return redAllow === "Y";
};

export const portfoliosByAvailableUnits = ({
  availableUnits = 0,
}: any): boolean => {
  return availableUnits > 0;
};

export const portfoliosWithIFSC = ({ bank }: any): boolean => {
  const { ifsc, neftIfsc } = bank || {};
  return !!ifsc; // || !!neftIfsc
};

export const portfoliosByDividend = ({
  taxStatus,
  age = 0,
  dob,
  ...rest
}: SCHEMES_RESPONSE): boolean => {
  const taxToUpper = taxStatus?.toUpperCase() || "";
  return (
    (taxToUpper === "01" ||
      taxToUpper === "02" ||
      NRI_CODES.includes(taxToUpper)) &&
    minorBelowEighteenYears({ taxStatus, age, dob, ...rest })
  );
};

export const checkAvailableUnits = ({
  availableUnits = 0,
}: SCHEMES_RESPONSE): boolean => {
  return availableUnits > 0;
};

export const portfoliosByChangeofTaxStatus = ({
  taxStatus,
  age = 0,
  dob,
  ...rest
}: SCHEMES_RESPONSE): boolean => {
  const taxToUpper = taxStatus?.toUpperCase() || "";
  return (
    (taxToUpper === "01" ||
      taxToUpper === "02" ||
      taxToUpper === "21" ||
      taxToUpper === "24") &&
    minorBelowEighteenYears({ taxStatus, age, dob, ...rest })
  );
};

/**
 *  This function is used to group schemes asset-class wise, and
 *  filtering the data using the given list of filter functions.
 *
 * @param folioList List of folios from getPortfolio
 * @param filterFunc  List of filter functions
 * @returns
 */
export function getPortfoliosFilteredData(
  folioList: PORTFOLIO_DATA_RESPONSE[] = [],
  filterFunc: Function[] = []
) {
  let data: RowInfoType[] = folioList.reduce(
    (prev: RowInfoType[], curr: PORTFOLIO_DATA_RESPONSE) => {
      const { schemes } = curr;
      schemes.forEach((scheme: SCHEMES_RESPONSE) => {
        let index = prev.findIndex(
          (ele: RowInfoType) => ele.id === scheme.folio
        );
        if (index !== -1) {
          const fund = prev[index];
          const { schemeNames = [], assetType = [] } = fund;
          prev[index] = {
            ...prev[index],
            schemeNames: [...schemeNames, scheme.schemeName],
            assetType: assetType.includes(scheme.assetType)
              ? assetType
              : [...assetType, scheme.assetType],
          };
          return;
        }
        const valid = filterFunc.every((func: Function) =>
          func.call({}, scheme)
        );
        if (
          !prev.find((ele: RowInfoType) => ele.id === scheme.folio) &&
          valid
        ) {
          prev = [
            ...prev,
            {
              id: scheme.folio,
              amcName: scheme.amcName,
              email: scheme.email,
              investorName: scheme.investorName,
              amc: scheme.amc,
              folio: scheme.folio,
              taxStatus: scheme.taxStatus || "",
              schemeNames: [scheme.schemeName],
              mobile: scheme.mobile,
              assetType: [scheme.assetType],
            },
          ];
        }
      });
      return prev;
    },
    []
  );
  return data;
}

export interface DIVIDEND_MATCHED_UNMATCHED_DATA_TYPE {
  matchedData: any[];
  unMatchedData: any[];
}

export function getDividendFilteredData(
  folioList: PORTFOLIO_DATA_RESPONSE[] = [],
  filterFunc: Function[] = []
) {
  let data = folioList.reduce(
    (
      prev: DividendTableRowType[],
      curr: PORTFOLIO_DATA_RESPONSE,
      currentIndex: number
    ) => {
      const { schemes } = curr;
      schemes.forEach((fund: DividendTableRowType, index: number) => {
        const valid = filterFunc.every((func: Function) => func.call({}, fund));
        if (valid) {
          prev = [...prev, { ...fund, id: currentIndex + `` + index }];
        }
      });
      return prev;
    },
    []
  );
  return data;
}

export function mapInvestorDetailsToPortfolios(
  nomineeFolios: INVETSOR_DETAILS_RESPONSE[],
  folioList: RowInfoType[]
): NomineeInfoRowData[] {
  const filteredNomineeByFolio = nomineeFolios.reduce(
    (prev: NomineeInfoRowData[], curr) => {
      curr?.investorDetails?.forEach((fund) => {
        prev = [
          ...prev,
          {
            ...fund,
            amc: curr.amc,
            amcName: curr.amcName,
            id: fund.folio,
            mobile: fund.mobile,
            investorName: fund.investorName,
            nominees: fund.nominees,
            assetType: [],
            taxStatusLabel: getTaxStatusCode[fund.taxStatus],
          },
        ];
      });
      return prev;
    },
    []
  );
  // To map assetType field to investor details
  return filteredNomineeByFolio.map((fund) => ({
    ...fund,
    assetType: folioList.find((_fund) => fund.id === _fund.id)?.assetType,
  }));
}

/**
 *  Consolodate Folois Filtering
 * @param nomineeFolios
 */
export function getInvestorFunds(
  nomineeFolios: INVETSOR_DETAILS_RESPONSE[],
  filterFunc: Function[] = [],
  defaultFilterFunc: Function[] | null = [
    portfoliosByMinorStatus,
    portfoliosByModeOfHolding,
  ]
) {
  return nomineeFolios.reduce((prev: ConsolidateTableRowType[], curr) => {
    curr.investorDetails.forEach((fund) => {
      if (
        [
          ...filterFunc,
          ...(!!defaultFilterFunc ? defaultFilterFunc : []),
          ({ matchFlag }: ConsolidateTableRowType) =>
            !matchFlag || matchFlag !== "N",
        ].every((func) => func.call({}, fund))
      ) {
        prev = [
          ...prev,
          {
            ...fund,
            amc: curr.amc,
            amcName: curr.amcName,
            id: fund.folio,
          },
        ];
      }
    });
    return prev;
  }, []);
}

export const modeOfHoldingSingle = ({ modeOfHolding = "" }: INVESTOR_OBJECT) =>
  modeOfHolding?.toUpperCase() === "SINGLE";

export const isNomineeStatusValid = ({
  nomineeStatus = "Y",
}: INVESTOR_OBJECT) => {
  nomineeStatus?.toUpperCase() !== "N";
};

export const taxStatusScenario = ({ taxStatus = "" }: INVESTOR_OBJECT) => {
  const taxStatusUpper = taxStatus?.toUpperCase() || "";
  return (
    taxStatusUpper === "01" ||
    taxStatusUpper === "02" ||
    NRI_CODES.includes(taxStatusUpper)
  );
};

export const transactionSourceScenarioEmpty = ({
  transactionSource,
}: INVESTOR_OBJECT) => !transactionSource;

/**
 * Check the fund is demat or not
 * @param param0
 * @returns
 */
export const dematFund = ({
  transactionSource = "",
}: SCHEMES_RESPONSE): boolean =>
  ["DEMAT", "EXCHANGE"].includes(transactionSource?.toUpperCase());

// export function correctionFolios(nomineeFolios: INVETSOR_DETAILS_RESPONSE[]): ConsolidateTableRowType{
//   return
// }

export interface BANK_DETAILS_WITH_NO_IFSC {
  amcName: string;
  amc: string;
  id: number | string;
  accountNo: string;
  accountType: string;
  branch: string;
  city: string;
  default: string;
  ifsc: string;
  micr: string;
  name: string;
  neftIfsc: string;
  pincode: PINCODE;
  assetType?: string[];
}
export const portfoliosWithNoIfsc = ({ ifsc, neftIfsc }: BANK): boolean => {
  return !(Boolean(ifsc) || Boolean(neftIfsc));
};

export function getIFSCDetails(
  nomineeFolios: INVETSOR_DETAILS_RESPONSE[],
  filterFunc: Function[] = []
) {
  return nomineeFolios.reduce((prev: BANK_DETAILS_WITH_NO_IFSC[], curr) => {
    curr.investorDetails.forEach(({ bank = [], ...fund }) => {
      const defaultBank: any =
        bank.find((_ele: BANK) => _ele.default === "Y") || {};
      if (
        portfoliosWithNoIfsc(defaultBank) &&
        filterFunc.every((func) => func.call({}, fund || {}))
      ) {
        prev = [
          ...prev,
          {
            ...defaultBank,
            amc: curr.amc,
            amcName: curr.amcName,
            id: fund.folio,
            assetType: fund.assetType,
            taxStatus: fund.taxStatus,
          },
        ];
      }
    });
    return prev;
  }, []);
}

export const fundsByLienFlag = ({
  lienUnitsFlag,
}: {
  lienUnitsFlag: "Y" | "N";
}): boolean => {
  return lienUnitsFlag !== "Y";
};

export const notLockedFolio = (scheme: any): boolean => {
  return !(scheme?.isLocked === "Y");
};

export const minorBelowEighteenYears = ({
  taxStatus,
  age = 0,
  dob,
}: SCHEMES_RESPONSE): boolean => {
  const taxToUpper = taxStatus?.toUpperCase();
  const aboveEighteen: boolean = !!age
    ? age > 18
    : !!dob
    ? new Date().getTime() - new Date(dob).getTime() >
      EIGHTEEN_YEARS_IN_MILLISECONDS
    : false;
  return !(
    (taxToUpper === "02" || taxToUpper === "26" || taxToUpper === "28") &&
    aboveEighteen
  );
};

export const checkIsValidObject = (object: any) => {
  if (typeof object !== "object") return false;
  return Object.values(object).every(
    (value) => !!value || typeof value === "boolean"
  );
};

export const isValidTaxDetail = (taxDetail: TaxDetails | undefined) => {
  if (!taxDetail) return false;
  if (!taxDetail.tinReason) {
    return !checkIsValidObject(taxDetail);
  }
  if (!taxDetail.countryTax) return false;
};

export const getErrorMessage = (
  row: any,
  dividendFilters: Function[]
): string => {
  if (!row.isDisabled) {
    return "";
  }

  const messageTable = {
    [portfoliosWithIFSC.name]: dbCommercial.errors.noIFSC,
    [ctPortfoliosByNROAccountType.name]: dbCommercial.errors.ct_nro,
    [ctPortfoliosByBankAccount.name]: dbCommercial.errors.bank,
    [ctPortfoliosByMinorStatus.name]: dbCommercial.errors.ct_minor,
    [checkAvailableUnits.name]: dbCommercial.errors.avaialbleUnits,
    [modeOfHoldingSingle.name]: dbCommercial.errors.moh,
    [fundsByLienFlag.name]: dashboard.ChangeDividend.noSelectLeinUnits,
    [noLienUnits.name]: dashboard.ChangeDividend.noSelectLeinUnits,
    [portfoliosByAvailableUnits.name]: dbCommercial.errors.noFundsAvailable,
    [portfoliosByRedemptionAllow.name]: dbCommercial.redemption.redemptionAllow,
    [disablePaytmBankForGrow.name]: dbCommercial.redemption.paytm,
    [notLockedFolio.name]: dbCommercial.errors.lockedFolio,
    [portfoliosByMinorStatus.name]: dbCommercial.errors.minorFolio,
    [portfoliosByTransactionResource.name]:
      dbCommercial.errors.transactionSourceNotAllowed,
  };

  const defaultError = dashboard.ChangeDividend.toolTip.info1;

  for (let filter of dividendFilters) {
    const failed = !filter.call({}, row);

    if (failed) {
      return messageTable[filter.name] || defaultError;
    }
  }

  return defaultError;
};
